import jsPDF from 'jspdf';

// ── A4 Portrait page geometry ──────────────────────────────────────────────────
export const PAGE_WIDTH = 210;   // mm
export const PAGE_HEIGHT = 297;  // mm
export const MARGIN_LEFT = 10;   // mm
export const MARGIN_RIGHT = 10;  // mm
export const RIGHT_EDGE = PAGE_WIDTH - MARGIN_RIGHT; // 200 mm

// ── Currency column x-positions (right side of page) ──────────────────────────
/** '$' sign right-aligned to this x */
export const DOLLAR_SIGN_X = RIGHT_EDGE - 35;
/** Numeric amount right-aligned to this x */
export const AMOUNT_X = RIGHT_EDGE - 1;

// ── Draw primitives ────────────────────────────────────────────────────────────

/** Draw a horizontal rule */
export const hline = (doc: jsPDF, x1: number, y: number, x2: number, lw = 0.3): void => {
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(lw);
  doc.line(x1, y, x2, y);
};

/** Draw a rectangle outline */
export const box = (doc: jsPDF, x: number, y: number, w: number, h: number, lw = 0.3): void => {
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(lw);
  doc.rect(x, y, w, h, 'S');
};
